import { OLAF } from 'HubStyleTokens/colors';
import styled, { css, keyframes } from 'styled-components';
import UIIconButton from 'UIComponents/button/UIIconButton';
import { GRADIENT, MAGENTA } from 'ai-components-ui-library/styles/colors';
const textInputBoxAnimation = ({
  disabled
}) => {
  const animation = keyframes(["from{background:", " !important;}to{background:#fc0849 !important;}"], MAGENTA[200]);
  if (!disabled) {
    return css(["animation:", " 1s ease-in !important;"], animation);
  }
  return css([""]);
};
const breezeButtonStyles = css(["margin:0 !important;height:25px;width:25px !important;min-width:25px !important;border:none !important;color:", " !important;background:", " !important;", ""], OLAF, ({
  disabled
}) => !disabled ? GRADIENT['DARK'] : MAGENTA[200], textInputBoxAnimation);
export const BreezeButton = styled(UIIconButton).attrs({
  use: 'unstyled'
}).withConfig({
  displayName: "BreezeButton",
  componentId: "sc-1h2yh9k-0"
})(["", ""], breezeButtonStyles);